import { Form, Typography, Input, Button } from 'antd';
import { ReactComponent as CloseIcon } from 'app/assets/img/close_icon.svg';
import ModalContainer from 'app/components/ModalContainer';
import useWindowSize, { TABLET_WIDTH } from 'app/hooks/useWindowSize';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import * as _ from 'lodash';
import { replaceDescription } from 'app/pages/App/components/OTPRegister';
import ExportPdfModal from 'app/pages/NewAccount/CheckTickets/ExportPdfModal/ExportPdfModal';
import { ruleEmailInput, ruleNameInput, rulePhoneInput } from 'utils/messages';
const CustomerInfoModal = ({
  isShow,
  onCloseDialog,
  onSumitRelease,
  isResetFrom,
  initCustomerInfo,
  readOnly,
  selectedTickets,
}: any) => {
  const translations = useSelector(selectTranslations);
  const { device } = useWindowSize();

  const onFinishFailed = errorInfo => {};
  const [form] = Form.useForm();

  useEffect(() => {
    if (isResetFrom) {
      form.resetFields();
    }
  }, [isResetFrom]);
  useEffect(() => {
    if (!_.isEmpty(initCustomerInfo)) {
      form.setFieldsValue({
        customerName: initCustomerInfo?.customerName,
        customerPhone: initCustomerInfo?.customerPhone,
        customerEmail: initCustomerInfo?.customerEmail,
        note: initCustomerInfo?.note,
      });
    }
  }, [initCustomerInfo]);
  return (
    <ModalContainer
      maskClosable={false}
      CloseIcon={
        device === 'mobile' || device === 'tablet' ? (
          <CloseIcon width={11} height={11} />
        ) : undefined
      }
      styleSlots={{
        modalContentStyle: {
          maxWidth: 800,
          width: '100%',
        },
        iconWrapperStyle: {
          margin: device === 'desktop' ? '16px 16px 0 0' : '0 -10px 0 0',
        },
      }}
      modalProps={{
        width: 'auto',
        style: {
          overscrollBehavior: 'none',
        },
      }}
      closable
      isShow={isShow}
      onCloseDialog={onCloseDialog}
    >
      <div>
        <StyledH4>
          {translations ? translations['b2b.customer-info-issue-ticket'] : ''}
        </StyledH4>
      </div>
      <Typography style={{ fontSize: 14, marginBottom: 20, fontWeight: 400 }}>
        {translations
          ? translations['b2b.txt.required-customer-info-issue-ticket']
          : ''}
      </Typography>
      <Form
        name="customer-info"
        onFinish={onSumitRelease}
        autoComplete="off"
        onFinishFailed={onFinishFailed}
        form={form}
      >
        <div
          style={{
            border: 'none',
            // borderBottom: '1px solid #EDEDED',
            marginBottom: 10,
          }}
        >
          <Form.Item
            style={{
              color: '#808080',
              marginBottom: 0,
            }}
            name="customerName"
            rules={readOnly ? undefined : ruleNameInput(translations)}
            required={false}
            validateFirst
            validateTrigger="onBlur"
            label={
              <span
                style={{
                  color: '#808080',
                  fontStyle: 'italic',
                  minWidth: 100,
                  textAlign: 'left',
                }}
              >
                {translations ? translations['b2c.txt.fullName'] : ''}
              </span>
            }
          >
            <Input
              maxLength={190}
              readOnly={readOnly}
              style={{
                height: '30px',
                border: 'none',
                borderBottom: '1px solid #EDEDED',
                outline: 'none',
                width: '100%',
                fontFamily: 'inherit',
                fontWeight: 400,
              }}
              autoComplete="off"
              onBlur={e => {
                form.setFieldsValue({
                  customerName: e.target.value?.trim(),
                });
              }}
            />
          </Form.Item>
        </div>

        <div
          style={{
            border: 'none',
            lineHeight: 0,
            marginBottom: 10,
          }}
        >
          <Form.Item
            style={{
              color: '#808080',
              marginBottom: 0,
            }}
            name="customerPhone"
            rules={readOnly ? undefined : rulePhoneInput(translations, false)}
            validateFirst
            validateTrigger="onBlur"
            label={
              <span
                style={{
                  color: '#808080',
                  fontStyle: 'italic',
                  minWidth: 100,
                  textAlign: 'left',
                }}
              >
                {translations ? translations['b2b.acc.phone'] : ''}
              </span>
            }
          >
            <Input
              type="text"
              name="customerPhone"
              maxLength={200}
              readOnly={readOnly}
              style={{
                height: '30px',
                border: 'none',
                borderBottom: '1px solid #EDEDED',
                outline: 'none',
                width: '100%',
                fontFamily: 'inherit',
                fontWeight: 400,
              }}
              autoComplete="off"
              onBlur={e => {
                form.setFieldsValue({
                  customerPhone: e.target.value?.trim(),
                });
              }}
              value={form.getFieldValue('customerPhone')}
              onChange={event => {
                const value = event.target.value;

                form.setFieldValue(
                  'customerPhone',
                  value.replace(/[^0-9]/g, ''),
                );
              }}
            />
          </Form.Item>
        </div>

        <div
          style={{
            border: 'none',
            lineHeight: 0,
            marginBottom: 10,
          }}
        >
          <Form.Item
            style={{
              color: '#808080',
              marginBottom: 0,
            }}
            name="customerEmail"
            rules={readOnly ? undefined : ruleEmailInput(true, translations)}
            required={false}
            validateFirst
            validateTrigger="onBlur"
            label={
              <span
                style={{
                  color: '#808080',
                  fontStyle: 'italic',
                  minWidth: 100,
                  textAlign: 'left',
                }}
              >
                {translations ? translations['b2c.freeticket.email'] : ''}
              </span>
            }
          >
            <Input
              type="text"
              readOnly={readOnly}
              name="customerEmail"
              maxLength={190}
              style={{
                height: '30px',
                border: 'none',
                borderBottom: '1px solid #EDEDED',
                outline: 'none',
                width: '100%',
                fontFamily: 'inherit',
                fontWeight: 400,
              }}
              autoComplete="off"
              onBlur={e => {
                form.setFieldsValue({
                  customerEmail: e.target.value?.trim(),
                });
              }}
            />
          </Form.Item>
        </div>

        <div
          style={{
            border: 'none',
            lineHeight: 0,
            marginBottom: 10,
          }}
        >
          <Form.Item
            style={{
              color: '#808080',
              marginBottom: 20,
            }}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            validateFirst
            name="note"
            label={
              <span>
                {translations ? translations['b2b.form.tourNotes'] : ''}
              </span>
            }
          >
            <Input.TextArea
              rows={4}
              maxLength={5000}
              readOnly={readOnly}
              name="note"
              placeholder={
                translations ? translations['b2b.txt.input-note'] : ''
              }
              style={{
                border: '1px solid #D0D5DD',
                borderRadius: '6px',
                outline: 'none',
                width: '100%',
                fontFamily: 'inherit',
                fontWeight: 400,
              }}
              autoComplete="off"
              onBlur={e => {
                form.setFieldsValue({
                  note: e.target.value?.trim(),
                });
              }}
            />
          </Form.Item>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 30,
          }}
        >
          <Button
            style={{
              color: '#808080',
              width: '170px',
              height: 48,
              fontWeight: 500,
              fontSize: '14px',
              borderRadius: '10px',
              marginRight: 10,
            }}
            onClick={onCloseDialog}
          >
            <i className="fa-solid fa-arrow-left"></i>
            <span
              className="--textBtn"
              style={{
                marginLeft: 8,
              }}
            >
              {translations ? translations['b2c.txt.back'] : ''}
            </span>
          </Button>
          {!readOnly && (
            <Form.Item>
              <ExportPdfModal
                form={form}
                isShowDownload={() => {
                  if (selectedTickets()?.[0]?.isLongTerm) {
                    return false;
                  }
                  const mailInput = form.getFieldValue('customerEmail');
                  const orderMail = initCustomerInfo?.customerEmail;

                  const isMailChange = Boolean(orderMail)
                    ? mailInput !== orderMail
                    : true;

                  const isMoreThanOneTicket =
                    _.isArray(selectedTickets()) &&
                    selectedTickets().length > 1;
                  if (isMoreThanOneTicket) {
                    return true;
                  }
                  return isMailChange;
                }}
              />
            </Form.Item>
          )}
          <Form.Item name="isZip" />
          <Form.Item name="isShowDownload" />
        </div>
      </Form>
    </ModalContainer>
  );
};

export default CustomerInfoModal;

const StyledH4 = styled.h4`
  line-height: 28px;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 32px;
  text-transform: uppercase;
  color: black;
  text-align: center;
`;
